import { theme } from '~/theme';

export const listItemHeight = 48;

export const useSxStyles = () => {
  return {
    refDiv: {
      display: 'flex',
      flexGrow: 1,
    },
    contentPadding: {
      padding: theme.spacing(0, 2),
    },
    dialogContentRoot: {
      paddingTop: 0,
      paddingBottom: theme.spacing(3),
    },
    listContainer: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(5),
      marginTop: theme.spacing(1.25),
      marginLeft: theme.spacing(2),
      borderTop: 'solid 1px #ddd',
    },
    listItemContainer: {
      minHeight: listItemHeight,
    },
    listItemComponentRoot: {
      height: '100%',
    },
  };
};
